import { Injectable } from '@angular/core';
import { XenaClient } from 'src/app/services';
import { ITermsData } from '../../dtos';
import { ISaveResult } from '../../response-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsCultureService {

  constructor(private xenaClient: XenaClient) {
  }

  saveAcceptedTerms(termsCultureId: number, data: ITermsData): Observable<ISaveResult> {
    const resourcePath: string = `/XenaTermsCulture/${termsCultureId}/Accept`;
    return this.xenaClient.put<ITermsData, ISaveResult>(resourcePath, data);
  }
}
